import { Injectable, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Injectable()
export class AssignmentsFilterForm {
  private formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    assignmentStatus: 'assignmentStatus',
    isArchived: 'isArchived',
    sortColumn: 'sortColumn',
    sortOrder: 'sortOrder'
  }

  public form: FormGroup;

  constructor() {
    this.form = this.formBuilder.group({
      new: new FormControl<boolean>(true),
      completed: new FormControl<boolean>(true),
      active: new FormControl<boolean>(true),
      postponed: new FormControl<boolean>(true),
      overdue: new FormControl<boolean>(true),
      isArchived: new FormControl<boolean>(false),
      sortColumn: new FormControl<string>('created_at'),
      sortOrder: new FormControl<boolean>(true),
    });
  }
}
